import type { Category, Consent } from './types';

const UNBLOCKED_ATTR = 'data-cookiesie-unblocked';

// mvp_b_plan.md §4.1: <script type="text/plain"> is inert; on consent we
// clone it as a real script tag (mutating `type` on the original would not
// re-execute it). <iframe data-cookie-src="…"> swaps src into place.
export function unblock(consent: Consent): void {
  unblockScripts(consent);
  unblockIframes(consent);
}

function unblockScripts(consent: Consent): void {
  const nodes = document.querySelectorAll<HTMLScriptElement>(
    'script[type="text/plain"][data-cookie-category]',
  );
  nodes.forEach((node) => {
    if (node.hasAttribute(UNBLOCKED_ATTR)) return;
    const cat = node.getAttribute('data-cookie-category') as Category | null;
    if (!cat || !consent[cat]) return;
    const fresh = document.createElement('script');
    // Copy attributes, except `type` (so it executes) and our marker.
    for (const a of Array.from(node.attributes)) {
      if (a.name === 'type') continue;
      fresh.setAttribute(a.name, a.value);
    }
    if (node.textContent) fresh.textContent = node.textContent;
    fresh.setAttribute(UNBLOCKED_ATTR, '1');
    node.setAttribute(UNBLOCKED_ATTR, '1');
    node.parentNode?.insertBefore(fresh, node.nextSibling);
  });
}

function unblockIframes(consent: Consent): void {
  const nodes = document.querySelectorAll<HTMLIFrameElement>(
    'iframe[data-cookie-src][data-cookie-category]',
  );
  nodes.forEach((node) => {
    if (node.hasAttribute(UNBLOCKED_ATTR)) return;
    const cat = node.getAttribute('data-cookie-category') as Category | null;
    const src = node.getAttribute('data-cookie-src');
    if (!cat || !src || !consent[cat]) return;
    node.setAttribute('src', src);
    node.setAttribute(UNBLOCKED_ATTR, '1');
  });
}
